/** Shared copy and URLs for Walk to the Board (popup + dedicated page). */

/** Non-community / open participants */
export const WALK_TO_BOARD_REGISTRATION_URL_NON_COMMUNITY =
  "https://rzp.io/rzp/DVFLAU3B";

/** Iron Lady community members */
export const WALK_TO_BOARD_REGISTRATION_URL_COMMUNITY =
  "https://rzp.io/rzp/VlF8M4Q2";

/** Default registration link (non-community). Home popup uses this. */
export const WALK_TO_BOARD_REGISTRATION_URL =
  WALK_TO_BOARD_REGISTRATION_URL_NON_COMMUNITY;

export const WALK_TO_BOARD_EVENT_PATH = "/events/walk-to-the-board";

export function getWalkToTheBoardEventImageUrl() {
  return `${process.env.PUBLIC_URL || ""}${encodeURI("/walk to the board.png")}`;
}

export const WALK_TO_BOARD_CITIES = [
  "Bangalore",
  "Hyderabad",
  "Delhi",
  "Mumbai",
  "Pune",
  "Kolkata",
  "Chennai",
];

export const WALK_TO_BOARD_CITIES_LINE = WALK_TO_BOARD_CITIES.join(" • ");

/** After this instant the home popup/teaser should not show. */
export const WALK_TO_BOARD_EVENT_END = new Date("2026-04-19T23:59:59");
